import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-bae7eb7c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "box" }
const _hoisted_2 = { class: "card-box" }
const _hoisted_3 = { class: "project-title" }
const _hoisted_4 = { class: "row between" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "blue" }, "查看明细", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tip grey" }, "项目资金概况", -1))
const _hoisted_8 = { class: "tip-card" }
const _hoisted_9 = { class: "row between" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "grey" }, "合同总金额", -1))
const _hoisted_11 = /*#__PURE__*/_createTextVNode()
const _hoisted_12 = { class: "black" }
const _hoisted_13 = { class: "row between" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "grey" }, "合同质保金", -1))
const _hoisted_15 = /*#__PURE__*/_createTextVNode()
const _hoisted_16 = { class: "grey" }
const _hoisted_17 = { class: "row between" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "grey" }, "已回款项", -1))
const _hoisted_19 = /*#__PURE__*/_createTextVNode()
const _hoisted_20 = { class: "black" }
const _hoisted_21 = { class: "row between" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "grey" }, "预估利润", -1))
const _hoisted_23 = /*#__PURE__*/_createTextVNode()
const _hoisted_24 = { class: "grey" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tip grey" }, "支出及成本概况", -1))
const _hoisted_26 = { class: "tip-card" }
const _hoisted_27 = { class: "row between" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "grey" }, "个人业务费用", -1))
const _hoisted_29 = /*#__PURE__*/_createTextVNode()
const _hoisted_30 = { class: "black" }
const _hoisted_31 = { class: "row between" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "grey" }, "货物成本", -1))
const _hoisted_33 = /*#__PURE__*/_createTextVNode()
const _hoisted_34 = { class: "grey" }
const _hoisted_35 = { class: "row between" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "grey" }, "安装成本", -1))
const _hoisted_37 = /*#__PURE__*/_createTextVNode()
const _hoisted_38 = { class: "black" }
const _hoisted_39 = { class: "row between" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "grey" }, "策划设计费", -1))
const _hoisted_41 = /*#__PURE__*/_createTextVNode()
const _hoisted_42 = { class: "grey" }
const _hoisted_43 = { class: "row between" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "grey" }, "招标费", -1))
const _hoisted_45 = /*#__PURE__*/_createTextVNode()
const _hoisted_46 = { class: "grey" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tip grey" }, "项目提成", -1))
const _hoisted_48 = { class: "tip-card" }
const _hoisted_49 = { class: "row between" }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "grey" }, "项目提点", -1))
const _hoisted_51 = /*#__PURE__*/_createTextVNode()
const _hoisted_52 = { class: "black" }
const _hoisted_53 = { class: "row between" }
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "grey" }, "预计奖励金额", -1))
const _hoisted_55 = /*#__PURE__*/_createTextVNode()
const _hoisted_56 = { class: "grey" }
const _hoisted_57 = { class: "row between" }
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "grey" }, "已完成奖励发放", -1))
const _hoisted_59 = /*#__PURE__*/_createTextVNode()
const _hoisted_60 = { class: "black" }

import { onMounted, ref } from 'vue'
import { useRouter } from 'vue-router'
import { ProjectData } from '@/apis/projectList'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter()
const project_id = ref(0)
const to_cost_detail = () => {
  router.push('costAccountingDetail?project_id=' + project_id.value)
}
const costDetails = ref({} as ProjectData)

onMounted(() => {
  project_id.value = Number(router.currentRoute.value.query.project_id)
  let data = JSON.parse(localStorage.getItem('PROJECT_DETAIL'))
  costDetails.value = data
})

return (_ctx: any,_cache: any) => {
  const _component_base_nav_bar = _resolveComponent("base-nav-bar")!
  const _component_van_icon = _resolveComponent("van-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_base_nav_bar, {
      title: _ctx.$route.meta.title,
      "left-text": "返回"
    }, null, 8, ["title"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(costDetails.value.name), 1),
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("div", { onClick: to_cost_detail }, [
          _hoisted_6,
          _createVNode(_component_van_icon, { name: "arrow" })
        ])
      ])
    ]),
    _hoisted_7,
    _createElementVNode("ul", _hoisted_8, [
      _createElementVNode("li", _hoisted_9, [
        _hoisted_10,
        _hoisted_11,
        _createElementVNode("span", _hoisted_12, "￥" + _toDisplayString(costDetails.value.contract?.money || '0.00'), 1)
      ]),
      _createElementVNode("li", _hoisted_13, [
        _hoisted_14,
        _hoisted_15,
        _createElementVNode("span", _hoisted_16, "￥" + _toDisplayString(costDetails.value.contract?.shelf_life_money || '0.00'), 1)
      ]),
      _createElementVNode("li", _hoisted_17, [
        _hoisted_18,
        _hoisted_19,
        _createElementVNode("span", _hoisted_20, "￥" + _toDisplayString(costDetails.value.receivable_money), 1)
      ]),
      _createElementVNode("li", _hoisted_21, [
        _hoisted_22,
        _hoisted_23,
        _createElementVNode("span", _hoisted_24, "￥" + _toDisplayString(costDetails.value.forecast_money), 1)
      ])
    ]),
    _hoisted_25,
    _createElementVNode("ul", _hoisted_26, [
      _createElementVNode("li", _hoisted_27, [
        _hoisted_28,
        _hoisted_29,
        _createElementVNode("span", _hoisted_30, "￥" + _toDisplayString(costDetails.value.person_fee), 1)
      ]),
      _createElementVNode("li", _hoisted_31, [
        _hoisted_32,
        _hoisted_33,
        _createElementVNode("span", _hoisted_34, "￥" + _toDisplayString(costDetails.value.goods_money), 1)
      ]),
      _createElementVNode("li", _hoisted_35, [
        _hoisted_36,
        _hoisted_37,
        _createElementVNode("span", _hoisted_38, "￥" + _toDisplayString(costDetails.value.installation_money), 1)
      ]),
      _createElementVNode("li", _hoisted_39, [
        _hoisted_40,
        _hoisted_41,
        _createElementVNode("span", _hoisted_42, "￥" + _toDisplayString(costDetails.value.planning_money), 1)
      ]),
      _createElementVNode("li", _hoisted_43, [
        _hoisted_44,
        _hoisted_45,
        _createElementVNode("span", _hoisted_46, "￥" + _toDisplayString(costDetails.value.tender_money), 1)
      ])
    ]),
    _hoisted_47,
    _createElementVNode("ul", _hoisted_48, [
      _createElementVNode("li", _hoisted_49, [
        _hoisted_50,
        _hoisted_51,
        _createElementVNode("span", _hoisted_52, _toDisplayString(costDetails.value.ticheng_tidian || 0) + "%", 1)
      ]),
      _createElementVNode("li", _hoisted_53, [
        _hoisted_54,
        _hoisted_55,
        _createElementVNode("span", _hoisted_56, "￥" + _toDisplayString(costDetails.value.ticheng_reward_money), 1)
      ]),
      _createElementVNode("li", _hoisted_57, [
        _hoisted_58,
        _hoisted_59,
        _createElementVNode("span", _hoisted_60, "￥" + _toDisplayString(costDetails.value.ticheng_honour_money), 1)
      ])
    ])
  ]))
}
}

})